module.exports = __webpack_public_path__ + "static/media/feature-ecommerce1.9a8e7113.png";